/**
 * Галерея фотографий клиники
 *
 * @param {Object} params
 * @param {String} params.buttonAnotherPhoto - кнопка скрытия и раскрытия дополнительных фотографий
 * @param {String} params.galleryCountItems - количество фотографий

 */
$.fn.clinicGallery = function (params) {

    const $self = $(this);
    const $buttonAnotherPhoto = $self.find(params.buttonAnotherPhoto);
    const galleryCountItems = $self.attr(params.galleryCountItems);

    let viewportWindow = $(window).width();
    let photoCount = galleryCountItems;

    if (viewportWindow >= Tools.xl) {
        photoCount = photoCount - 8;
    }

    if (viewportWindow < Tools.xl && viewportWindow >= Tools.lg) {
        photoCount = photoCount - 6;
    }

    if (viewportWindow < Tools.lg && viewportWindow >= Tools.md) {
        photoCount = photoCount - 4;
    }

    if (viewportWindow < Tools.md) {
        photoCount = photoCount - 1;
    }

    if (photoCount > 0) {
        $buttonAnotherPhoto.show();
    } else {
        $buttonAnotherPhoto.hide();
    }

    return this;
};

// инициализация
const init = function () {

    $('#clinic-gallery-module').clinicGallery({
        buttonAnotherPhoto: $('[data-button-another-photo="true"]'),
        galleryCountItems: 'data-gallery-count-items',

    });
};

if ($('#clinic-gallery-module').length > 0) {
    init();
}